export const ChartHistogram = ({
  height = "16",
  width = "16",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_92_5454)">
      <path
        d="M2.33325 14.6507C2.15644 14.6507 1.98687 14.5804 1.86185 14.4554C1.73682 14.3304 1.66659 14.1608 1.66659 13.984V0H0.333252V13.984C0.333252 14.5144 0.543966 15.0231 0.919038 15.3982C1.29411 15.7733 1.80282 15.984 2.33325 15.984H16.3333V14.6507H2.33325Z"
        fill="#706A85"
      />
      <path d="M4.99984 8H3.6665V12.6667H4.99984V8Z" fill="#706A85" />
      <path d="M8.33333 6.66699H7V12.667H8.33333V6.66699Z" fill="#706A85" />
      <path
        d="M11.6666 8.66699H10.3333V12.667H11.6666V8.66699Z"
        fill="#706A85"
      />
      <path d="M14.9998 6H13.6665V12.6667H14.9998V6Z" fill="#706A85" />
      <path
        d="M7.66648 2.94265L10.9998 6.27598L16.1378 1.13798L15.1952 0.195312L10.9998 4.39065L7.66648 1.05731L3.86182 4.86198L4.80448 5.80465L7.66648 2.94265Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_92_5454">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.333252)"
        />
      </clipPath>
    </defs>
  </svg>
);
